import React from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'
import styles from './styles.css'

interface NavItemMenuOptionProps extends Omit<NavLinkProps, 'to'> {
  to?: string
  onClick?: () => void
}

const NavItemMenuOption: React.FC<NavItemMenuOptionProps> = ({ to, children, onClick }) => {
  return (
    <li className={styles.navItemMenu} onClick={onClick}>
      {to ? (
        <NavLink
          to={to}
          className={styles.navItemMenuOption}
          activeClassName={styles.navItemMenuOptionActive}
        >
          {children}
        </NavLink>
      ) : (
        <div className={styles.navItemMenuOption}>{children}</div>
      )}
    </li>
  )
}

export default NavItemMenuOption
